<script>
  export let titre;
  export let text;
</script>

<div class="wrap-collabsible">
  <input id="collapsible2" class="toggle2" type="checkbox" />
  <label for="collapsible2" class="lbl-toggle2">
    {titre}

    <span class="cl-header-icon arrow">
      <svg viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"></path>
      </svg>
    </span>
  </label>
  <div class="collapsible-content2">
    <div class="content-inner2">
      <p>
        {@html text}
      </p>
    </div>
  </div>
</div>

<style>
  .cl-header-icon svg {
    display: inline-block;
    width: 35px;
    height: auto;
  }
  .lbl-toggle2 .arrow svg {
    transition: transform 0.25s ease-out;
  }

  .toggle2:checked + .lbl-toggle2 .arrow svg {
    transform: rotate(180deg);
  }

  input[type='checkbox'] {
    display: none;
  }
  .wrap-collabsible {
    margin: 1.2rem 0;
  }
  .lbl-toggle2 {
    display: inline-block;
    font-family: 'introblack';
    font-size: 24px;
    width: 100%;
    text-align: center;
    padding: 1rem;
    color: #fff;
    background: #909090;
    cursor: pointer;
    transition: all 0.25s ease-out;
  }
  .lbl-toggle2:hover {
    color: #fff;
  }
  /* .lbl-toggle2::before {
    content: ' ';
    display: inline-block;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid currentColor;
    vertical-align: middle;
    margin-right: 0.7rem;
    transform: translateY(-2px);
    transition: transform 0.2s ease-out;
  }
  .toggle2:checked + .lbl-toggle2::before {
    transform: rotate(90deg) translateX(-3px);
  } */
  .collapsible-content2 {
    max-height: 0px;
    overflow: hidden;
    transition: max-height 0.25s ease-in-out;
  }
  .toggle2:checked + .lbl-toggle2 + .collapsible-content2 {
    max-height: 350px;
  }
  .toggle2:checked + .lbl-toggle2 {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .collapsible-content2 .content-inner2 {
    color: #fff;
    text-align: left;
    padding: 20px 0 0;
  }
  .collapsible-content2 p {
    margin-bottom: 0;
  }
  @media only screen and (max-width: 768px) {
    .collapsible-content2 .content-inner2 {
      padding: 20px;
    }
  }
</style>
